function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import loadingSuccess from './loadingSuccess.json';
import LottieAnimation from '../LottieAnimation';

const LoadingSuccess = ({ ...props
}) => /*#__PURE__*/React.createElement(LottieAnimation, _extends({
  icon: loadingSuccess,
  overideHeight: 40,
  overideWidth: 80,
  ariaLabel: "succes",
  autoPlay: true
}, props));

export default LoadingSuccess;